import Vue from 'vue'
import VueInsProgressBar from 'vue-ins-progress-bar'

Vue.use(VueInsProgressBar, {
  position: 'fixed',
  show: true,
  height: '3px'
})
